function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { MultiSelect, getCreateNewItem } from "@blueprintjs/select";
import { Keys, Button, MenuItem, Tag } from "@blueprintjs/core";
import React from "react";
import { filter, isEqual } from "lodash";
import classNames from "classnames";
import "./style.css";
import { withProps } from "recompose";
import fuzzysearch from "fuzzysearch";
import getTextFromEl from "../utils/getTextFromEl";
import { getTagColorStyle, getTagProps } from "../utils/tagUtils";
import popoverOverflowModifiers from "../utils/popoverOverflowModifiers";

var TgSelect = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(TgSelect, _React$Component);

  function TgSelect(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "itemRenderer", function (i, _ref) {
      var index = _ref.index,
          handleClick = _ref.handleClick,
          modifiers = _ref.modifiers;

      var optionRenderer = _this.getOptionRenderer();

      var onClick = i.onClick || handleClick;
      return /*#__PURE__*/React.createElement("div", {
        //we specifically don't use a BP MenuItem component here because the menu item is too slow when 100s are loaded and will cause the component to lag
        onClick: modifiers.disabled ? undefined : onClick,
        key: index,
        className: classNames("tg-select-option bp3-menu-item bp3-fill bp3-text-overflow-ellipsis", {
          "bp3-active": modifiers.active,
          "bp3-disabled": modifiers.disabled
        })
      }, optionRenderer ? optionRenderer(i, _this.props) : i.label);
    });

    _defineProperty(_assertThisInitialized(_this), "tagRenderer", function (i) {
      if (!i || !_this.props.multi && _this.state.query) {
        return null;
      } // return i


      return i.label;
    });

    _defineProperty(_assertThisInitialized(_this), "handleItemSelect", function (item, e) {
      e.stopPropagation();
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          value = _this$props.value,
          multi = _this$props.multi,
          closeOnSelect = _this$props.closeOnSelect,
          isTagSelect = _this$props.isTagSelect;

      _this.setState({
        activeItem: null
      });

      if (multi) {
        var valArray = getValueArray(value);

        if (closeOnSelect || item.closeOnSelect) {
          _this.setState({
            isOpen: false
          });

          _this.input && _this.input.blur();
        }

        if (isTagSelect && item.value && item.value.includes && item.value.includes(":")) {
          var topLevelId = item.value.split(":")[0];
          valArray = valArray.filter(function (val) {
            if (val.value && val.value.includes && val.value.includes(":")) {
              var valId = val.value.split(":")[0];

              if (valId === topLevelId) {
                return false;
              }
            }

            return true;
          });
        }

        return onChange([].concat(valArray, [item]));
      } else {
        _this.setState({
          isOpen: false
        });

        _this.input && _this.input.blur();
        return onChange(item);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleTagRemove", function (e, tagProps) {
      var _this$props2 = _this.props,
          onChange = _this$props2.onChange,
          value = _this$props2.value;
      var filteredVals = filter(value, function (obj, i) {
        return !isEqual(i, tagProps["data-tag-index"]);
      });
      e.stopPropagation();
      onChange(filteredVals);

      _this.setState({
        isOpen: false
      });

      _this.input.focus();
    });

    _defineProperty(_assertThisInitialized(_this), "handleTagInputRemove", function (val, index) {
      var _this$props3 = _this.props,
          onChange = _this$props3.onChange,
          value = _this$props3.value;
      var filteredVals = filter(value, function (obj, i) {
        return !isEqual(i, index);
      }); // e.stopPropagation();

      return onChange(filteredVals);
    });

    _defineProperty(_assertThisInitialized(_this), "handleClear", function (e) {
      var _this$props4 = _this.props,
          multi = _this$props4.multi,
          value = _this$props4.value;
      e.stopPropagation();
      e.preventDefault();
      var newValue = null;

      if (multi) {
        newValue = filter(value, function (obj) {
          return obj.disabled;
        }) || [];
      } else if (value && value.disabled) {
        newValue = value;
      }

      var onChange = _this.props.onChange;

      _this.setState({
        query: ""
      });

      onChange(newValue);

      _this.setState({
        isOpen: false
      });

      _this.input.focus();
    });

    _defineProperty(_assertThisInitialized(_this), "itemListPredicate", function (queryString, item) {
      // this will hide an option if it returns false
      // each item is an individual option item
      var isSimpleSearch = _this.props.isSimpleSearch;
      return itemListPredicate(queryString, item, isSimpleSearch);
    });

    _defineProperty(_assertThisInitialized(_this), "onQueryChange", function (query) {
      var _this$props$onInputCh = _this.props.onInputChange,
          onInputChange = _this$props$onInputCh === void 0 ? function () {} : _this$props$onInputCh;

      _this.setState({
        query: query
      });

      onInputChange(query);
    });

    _defineProperty(_assertThisInitialized(_this), "handleActiveItemChange", function (item, isCreateNewItem) {
      _this.setState({
        activeItem: item || ( //if there's no item and we're in creatable mode, auto-select the create-new option
        isCreateNewItem || _this.props.creatable ? getCreateNewItem() : null)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onInteraction", function () {
      if (_this.input != null && _this.input !== document.activeElement) {
        // the input is no longer focused so we can close the popover
        _this.setState({
          isOpen: false,
          query: ""
        });
      } else if (!_this.props.openOnKeyDown) {
        // open the popover when focusing the tag input
        _this.setState({
          isOpen: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "queryHasExactOptionMatch", function () {
      //we don't want to show the creatable if the thing being created already exactly matches the label
      return [].concat(_this.props.options || [], Array.isArray(_this.props.value) ? _this.props.value : [_this.props.value]).filter(function (o) {
        var _ref2 = o || {},
            label = _ref2.label,
            value = _ref2.value;

        getTextFromEl();
        var lowerQuery = (_this.state.query || "").toLowerCase();
        var lowerLabelOrVal = label && label.toLowerCase ? label.toLowerCase() : value && value.toLowerCase && value.toLowerCase();
        var textFromEl = getTextFromEl(label);
        return lowerQuery === lowerLabelOrVal || lowerQuery === textFromEl;
      }).length > 0;
    });

    _defineProperty(_assertThisInitialized(_this), "getTagProps", function (label) {
      var _this$props5 = _this.props,
          multi = _this$props5.multi,
          _this$props5$value = _this$props5.value,
          value = _this$props5$value === void 0 ? [] : _this$props5$value,
          _disabled = _this$props5.disabled;
      var val = Array.isArray(value) ? value : [value];
      var matchingVal = val.find(function (op) {
        return op.label === label;
      });
      var disabled = _disabled || matchingVal && matchingVal.disabled;
      var className = matchingVal && matchingVal.className;
      return _extends({}, getTagColorStyle(multi && matchingVal && matchingVal.color), {
        intent: disabled ? "" : "primary",
        minimal: true,
        className: classNames(className, "tg-select-value", {
          disabled: disabled
        }),
        onRemove: multi && !disabled ? _this.handleTagRemove : null
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getOptionRenderer", function () {
      var _this$props6 = _this.props,
          isTagSelect = _this$props6.isTagSelect,
          optionRenderer = _this$props6.optionRenderer,
          multi = _this$props6.multi;

      if (isTagSelect && multi) {
        return tagOptionRender;
      }

      return optionRenderer;
    });

    var _this$props$autoOpen = _this.props.autoOpen,
        autoOpen = _this$props$autoOpen === void 0 ? false : _this$props$autoOpen;
    _this.state = {
      isOpen: autoOpen,
      activeItem: null,
      query: ""
    };
    return _this;
  }

  var _proto = TgSelect.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props7 = this.props,
        multi = _this$props7.multi,
        options = _this$props7.options,
        unfilteredOptions = _this$props7.unfilteredOptions,
        value = _this$props7.value,
        creatable = _this$props7.creatable,
        optionRenderer = _this$props7.optionRenderer,
        tagInputProps = _this$props7.tagInputProps,
        autoFocus = _this$props7.autoFocus,
        autoOpen = _this$props7.autoOpen,
        noResultsText = _this$props7.noResultsText,
        _this$props7$noResult = _this$props7.noResults,
        noResults = _this$props7$noResult === void 0 ? noResultsDefault : _this$props7$noResult,
        inputProps = _this$props7.inputProps,
        placeholder = _this$props7.placeholder,
        isLoading = _this$props7.isLoading,
        disallowClear = _this$props7.disallowClear,
        onBlur = _this$props7.onBlur,
        disabled = _this$props7.disabled,
        popoverProps = _this$props7.popoverProps,
        additionalRightEl = _this$props7.additionalRightEl,
        _this$props7$resetOnS = _this$props7.resetOnSelect,
        resetOnSelect = _this$props7$resetOnS === void 0 ? true : _this$props7$resetOnS,
        rest = _objectWithoutPropertiesLoose(_this$props7, ["multi", "options", "unfilteredOptions", "value", "creatable", "optionRenderer", "tagInputProps", "autoFocus", "autoOpen", "noResultsText", "noResults", "inputProps", "placeholder", "isLoading", "disallowClear", "onBlur", "disabled", "popoverProps", "additionalRightEl", "resetOnSelect"]);

    var hasValue = Array.isArray(value) ? value.length > 0 : !!value || value === 0;
    var rightElement = isLoading ? /*#__PURE__*/React.createElement(Button, {
      loading: true,
      minimal: true
    }) : /*#__PURE__*/React.createElement("span", null, additionalRightEl, hasValue && !disallowClear && !disabled && /*#__PURE__*/React.createElement(Button, {
      className: "tg-select-clear-all",
      icon: "cross",
      minimal: true,
      onClick: this.handleClear
    }), /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick(e) {
        if (_this2.state.isOpen) {
          e.stopPropagation();

          _this2.setState({
            isOpen: false
          });
        }
      },
      disabled: disabled,
      className: "tg-select-toggle",
      minimal: true,
      icon: this.state.isOpen ? "caret-up" : "caret-down"
    }));
    var maybeCreateNewItemFromQuery = creatable ? createNewOption : undefined;
    var maybeCreateNewItemRenderer = creatable && !this.queryHasExactOptionMatch() ? renderCreateNewOption : null;
    var selectedItems = getValueArray(value).map(function (value) {
      if (value && value.label) return value; //if the value has a label, just use that
      //if not, look for an existing option to use that value
      // unfilteredOptions will have every option included selected ones

      return unfilteredOptions.find(function (opt) {
        return opt && opt.value === (value && value.value || value);
      });
    });
    return /*#__PURE__*/React.createElement(MultiSelect, _extends({
      onActiveItemChange: this.handleActiveItemChange,
      closeOnSelect: !multi,
      resetOnSelect: resetOnSelect,
      items: options || [],
      activeItem: this.state.activeItem || options && options.filter(function (opt) {
        return !selectedItems.includes(opt);
      })[0] || null //it's important we pass null here instead of undefined if no active item is found
      ,
      itemDisabled: itemDisabled,
      query: this.state.query,
      popoverProps: _extends({
        minimal: true,
        className: classNames("tg-select", "tg-stop-dialog-form-enter", {
          "tg-single-select": !multi
        }),
        wrapperTagName: "div",
        canEscapeKeyClose: true,
        onInteraction: this.onInteraction,
        isOpen: this.state.isOpen,
        modifiers: popoverOverflowModifiers
      }, popoverProps),
      onItemSelect: this.handleItemSelect,
      createNewItemFromQuery: maybeCreateNewItemFromQuery,
      createNewItemRenderer: maybeCreateNewItemRenderer,
      noResults: noResultsText || noResults,
      onQueryChange: this.onQueryChange,
      itemRenderer: this.itemRenderer,
      itemListPredicate: this.itemListPredicate,
      selectedItems: selectedItems,
      tagRenderer: this.tagRenderer,
      tagInputProps: _extends({
        inputRef: function inputRef(n) {
          if (n) _this2.input = n;
        },
        placeholder: placeholder || (creatable ? "Select/Create..." : "Select..."),
        tagProps: this.getTagProps,
        onRemove: multi ? this.handleTagInputRemove : null,
        rightElement: rightElement,
        disabled: disabled
      }, tagInputProps, {
        //spread additional tag input props here
        intent: this.props.intent,
        onKeyDown: function onKeyDown(e) {
          var which = e.which;
          e.persist();

          if (which === Keys.ENTER) {
            e.preventDefault(); // e.stopPropagation();
          }

          if (which === Keys.ESCAPE || which === Keys.TAB) {
            // By default the escape key will not trigger a blur on the
            // input element. It must be done explicitly.
            if (_this2.input != null) {
              _this2.input.blur();
            }

            _this2.setState({
              isOpen: false
            });

            e.preventDefault();
            e.stopPropagation(); //this prevents dialog's it is in from closing
          } else if (!(which === Keys.BACKSPACE || which === Keys.ARROW_LEFT || which === Keys.ARROW_RIGHT)) {
            _this2.setState({
              isOpen: true
            });
          }
        },
        inputProps: _extends({
          autoFocus: autoFocus || autoOpen,
          onBlur: onBlur
        }, tagInputProps && tagInputProps.inputProps)
      })
    }, rest));
  };

  return TgSelect;
}(React.Component);

_defineProperty(TgSelect, "defaultProps", {
  onChange: function onChange() {},
  options: [],
  unfilteredOptions: [],
  value: undefined
});

export default withProps(function (props) {
  var multi = props.multi,
      value = props.value,
      options = props.options;
  var optionsToRet = options; // based on incoming value hide those selected options from the option list

  if (multi && value) {
    var valArray = getValueArray(value);
    optionsToRet = options.filter(function (op) {
      var isOptionSelected = valArray.some(function (val) {
        if (!val) return false;
        var matching = isEqual(val.value, op.value);
        return matching;
      });
      return !isOptionSelected;
    });
  }

  return {
    // unfilteredOptions is needed for finding selected items
    unfilteredOptions: options,
    options: optionsToRet
  };
})(TgSelect);

var itemDisabled = function itemDisabled(i) {
  return i.disabled;
};

var noResultsDefault = /*#__PURE__*/React.createElement("div", null, "No Results...");
export var renderCreateNewOption = function renderCreateNewOption(query, active, handleClick) {
  return /*#__PURE__*/React.createElement(MenuItem, {
    icon: "add",
    text: "Create \"" + query + "\"",
    active: active,
    onClick: handleClick,
    shouldDismissPopover: false
  });
};
export function createNewOption(newValString) {
  return {
    userCreated: true,
    label: newValString,
    value: newValString
  };
}

function getValueArray(value) {
  return value || value === 0 ? Array.isArray(value) ? value : [value] : [];
} //we export this here for use in createGenericSelect


export var itemListPredicate = function itemListPredicate(_queryString, items, isSimpleSearch) {
  if (_queryString === void 0) {
    _queryString = "";
  }

  var queryString = _queryString.toLowerCase();

  var toSearchArr = (items || []).map(function (item) {
    return {
      item: item,
      text: item.toLowerCase ? item.toLowerCase() : item.label ? item.label.toLowerCase ? item.label.toLowerCase() : getTextFromEl(item.label).toLowerCase() : item.value && item.value.toLowerCase && item.value.toLowerCase() || ""
    };
  });
  var toRet = toSearchArr.filter(function (_ref3) {
    var text = _ref3.text;
    return (isSimpleSearch ? simplesearch : fuzzysearch)(queryString, text);
  });
  toRet = toRet.sort(function (_ref4, _ref5) {
    var text = _ref4.text;
    var text2 = _ref5.text;
    return getSort(text, queryString) - getSort(text2, queryString);
  });
  toRet = toRet.map(function (_ref6) {
    var item = _ref6.item;
    return item;
  });
  return toRet;
};
export function simplesearch(needle, haystack) {
  return (haystack || "").indexOf(needle) !== -1;
}

function tagOptionRender(vals) {
  if (vals.noTagStyle) return vals.label;
  return /*#__PURE__*/React.createElement(Tag, getTagProps(vals));
}

function getSort(text, queryString) {
  var ret;
  if (text === queryString) ret = 0;else if (text.includes(queryString)) ret = 0.9;else ret = 1;
  return ret;
}